import { useState } from "react";
import { Tab } from "semantic-ui-react";
import { IModalProps } from "../../../../components/Jurados/InterfaceProp";
import TablaJurados from "./tablaJurados";
import TablaDePostulados from "./tablaPostulados";

const Tabs = ({
  setJurados,
  setPrimeroDatostabla,
  Tabla,
  inputFilter,
  selectFilter,
  userPermissions,
  filterByMany,
  primeroDatostabla,
}: any) => {
  const [enableObservation, setEnableObservation] = useState<any>(false);

  let tabSelect;

  if (userPermissions) {
    tabSelect = "Postulado";
  } else {
    tabSelect = "";
  }

  const panes = [
    {
      menuItem: "Banco de jurados",
      key: "1",
      pane: (
        <Tab.Pane
          key="1"
          attached={false}
          style={{ border: "none", backgroundColor: "#f0f2f5", padding: "0" }}
          className="tab-pane-jurados"
        >
          <TablaJurados
            setJurados={setJurados}
            onClick={() => setEnableObservation(false)}
            setPrimeroDatostabla={setPrimeroDatostabla}
            primeroDatostabla={primeroDatostabla}
            filterByMany={filterByMany}
            inputFilter={inputFilter}
            selectFilter={selectFilter}
            userPermissions={userPermissions}
            Tabla={Tabla}
          />
        </Tab.Pane>
      ),
    },
    {
      menuItem: tabSelect,
      key: "2",
      pane: (
        <Tab.Pane
          key="2"
          attached={false}
          style={{ border: "none", backgroundColor: "#f0f2f5", padding: "0" }}
          className="tab-pane-jurados"
        >
          {" "}
          {userPermissions ? (
            <TablaDePostulados
              setJurados={setJurados}
              enableObservation={enableObservation}
              setPrimeroDatostabla={setPrimeroDatostabla}
              onClick={() => setEnableObservation(true)}
              filterByMany={filterByMany}
              inputFilter={inputFilter}
              selectFilter={selectFilter}
              userPermissions={userPermissions}
              Tabla={Tabla}
              primeroDatostabla={primeroDatostabla}
            />
          ) : null}
        </Tab.Pane>
      ),
    },
  ];
  return (
    <Tab
      className="h-100"
      panes={panes}
      menu={{ secondary: true, pointing: true }}
      renderActiveOnly={false}
    />
  );
};

export default Tabs;
